import { useState, useRef } from 'react';

//El hook es una función que acepta una función "onDrop" como argumento.
//Custom Hook para activar una función de arraste de archivos multimedia.
const useDragAndDrop = (onDrop) => {

  const [isDragging, setIsDragging] = useState(false); //Estado para actualizar si se está arrastrando algo sobre el área.
  const dropAreaRef = useRef(null); //Referencia del contenedor sobre el cuál se quiere aplicar la funcionalidad.

  const handleDragOver = (event) => { //Función cuándo el elemento arrastrado entra en el área.
    event.preventDefault(); //Evitar comportamiento predeterminado del ordenador.
    setIsDragging(true); //Establecer el estado en true.
  };

  const handleDragLeave = () => { //Función cuándo el elemento arrastrado sale del área
    setIsDragging(false); //Establecer el estado en false.
  };

  const handleDrop = (event) => { //Función cuando se sueltan los archivos sobre el área de arrastrar y soltar.
    event.preventDefault();
    setIsDragging(false);
    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      onDrop(files);
    }
  };

  return { dropAreaRef, isDragging, handleDragOver, handleDragLeave, handleDrop };
};

export default useDragAndDrop;
